import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { DupeSettingsViewModel, LeadsDuplicateDetectionService } from '../leads-duplicate-detection.service';

@Component({
  selector: 'app-facebook-settings',
  templateUrl: './facebook-settings.component.html',
  styleUrls: ['./facebook-settings.component.scss'],
  standalone: false,
})
export class FacebookSettingsComponent implements OnInit {
  @Output() selectedSettings = new EventEmitter<DupeSettingsViewModel>();
  dupeOptionsForTemplate = DupeSettingsViewModel;
  duplicateConfigIsLoading$: Observable<boolean>;
  newDuplicateSettings$: Observable<DupeSettingsViewModel>;

  constructor(private readonly duplicateDetectionService: LeadsDuplicateDetectionService) {}

  ngOnInit(): void {
    this.duplicateDetectionService.loadDuplicateConfig();
    this.duplicateConfigIsLoading$ = this.duplicateDetectionService.isLoading$;
    this.newDuplicateSettings$ = this.duplicateDetectionService.newDuplicateSettings$;
  }

  changeSettings(d: DupeSettingsViewModel): void {
    this.duplicateDetectionService.updateCriteria(d);
    this.selectedSettings.emit(d);
  }

  saveSettings(): void {
    this.duplicateDetectionService.saveCriteria();
  }

  revertSettings(): void {
    this.duplicateDetectionService.revertCriteria();
  }
}
